module.exports = __webpack_public_path__ + "media/images/svg/logo_eclectick-47774cb49398ac3f032f707206d2c27c.svg";